import api from '../../../api/clinique/_parametre'

export default {
    getCodeProduitAssurance(data) {
        return new Promise((resolve, reject) => {
            api.getCodeProduitAssurance(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}